export default __webpack_public_path__ + "static/media/cameragot-screenshot-04.d8307cea.png";